"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1029. Curso Actuaciones ante los Matratos
    {
        id: 1029,
        tax: 0.21,
        sku: "iopos.course.online.curso-actuaciones-ante-los-maltratos-2026",
        title: "Curs Actuacions davant els Maltractaments",
        name: "Curs Actuacions davant els Maltractaments",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals policials en la intervenció integral davant situacions de maltractament, amb criteri jurídic, psicològic i operatiu.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1029/image1"],
        banner: ["/1029/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuaciones-ante-los-maltratos-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1030, 1031],
        multiple_languages: false,
    },
    // 1030. Curso Actuaciones Antes Los Maltratos - ES
    {
        id: 1030,
        tax: 0.21,
        sku: "iopos.course.online.curso-actuaciones-ante-los-maltratos-2026-es",
        title: "Curso Actuaciones ante los Maltratos.",
        name: "Curso Actuaciones ante los Maltratos.",
        short: "1.) Actuaciones ante los Maltratos",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1029/image1"],
        banner: ["/1029/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuaciones-ante-los-maltratos-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1029,
        evolmind: { course_id: 997, group_id: [2836] },
    },
    // 1031. Curso Actuaciones Antes Los Maltratos - CA
    {
        id: 1031,
        tax: 0.21,
        sku: "iopos.course.online.curso-actuaciones-ante-los-maltratos-2026-ca",
        title: "Curs Actuacions davant els Maltractaments.",
        name: "Curs Actuacions davant els Maltractaments.",
        short: "1.) Actuacions davant els Maltractaments",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1029/image1"],
        banner: ["/1029/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuaciones-ante-los-maltratos-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1029,
        evolmind: { course_id: 1000, group_id: [2839] },
    },
    // 1032. Curso Autprotección y Control Policial
    {
        id: 1032,
        tax: 0.21,
        sku: "iopos.course.online.curso-autoproteccion-y-control-policial-2026",
        title: "Curs Autoprotecció i Control Policial.",
        name: "Curs Autoprotecció i Control Policial.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació operativa especialitzada orientada a desenvolupar competències d’autoprotecció, control físic i ús proporcional de la força en intervencions policials de risc.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1032/image1"],
        banner: ["/1032/image1"],
        link: "/tienda/cursos/formacion-policial/curso-autoproteccion-y-control-policial-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1033, 1034],
        multiple_languages: false,
    },
    // 1033. Curso Autoprotección y Control Policial - ES
    {
        id: 1033,
        tax: 0.21,
        sku: "iopos.course.online.curso-autoproteccion-y-control-policial-2026-es",
        title: "Curso Autoprotección y Control Policial.",
        name: "Curso Autoprotección y Control Policial.",
        short: "1.) Autoprotección y Control Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1032/image1"],
        banner: ["/1032/image1"],
        link: "/tienda/cursos/formacion-policial/curso-autoproteccion-y-control-policial-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1032,
        evolmind: { course_id: 1003, group_id: [2842] },
    },
    // 1034. Curso Autoprotección y Control Policial - CA
    {
        id: 1034,
        tax: 0.21,
        sku: "iopos.course.online.curso-autoproteccion-y-control-policial-2026-ca",
        title: "Curs Autoprotecció i Control Policial",
        name: "Curs Autoprotecció i Control Policial",
        short: "1.) Autoprotecció i Control Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1032/image1"],
        banner: ["/1032/image1"],
        link: "/tienda/cursos/formacion-policial/curso-autoproteccion-y-control-policial-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1032,
        evolmind: { course_id: 1006, group_id: [2845] },
    },
    // 1035. Curso Extranjería Policial I
    {
        id: 1035,
        tax: 0.21,
        sku: "iopos.course.online.curso-extranjeria-policial-i-2026",
        title: "Curs Estrangeria Policial I",
        name: "Curs Estrangeria Policial I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació especialitzada orientada a aplicar amb criteri jurídic i operatiu la normativa d’estrangeria en l’actuació policial, garantint intervencions segures i respectuoses amb els drets fonamentals.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1035/image1"],
        banner: ["/1035/image1"],
        link: "/tienda/cursos/formacion-policial/curso-extranjeria-policial-i/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1036, 1037],
        multiple_languages: false,
    },
    // 1036. Curso Extranjería Policial I - ES
    {
        id: 1036,
        tax: 0.21,
        sku: "iopos.course.online.curso-extranjeria-policial-i-2026-es",
        title: "Curso Extranjería Policial I.",
        name: "Curso Extranjería Policial I.",
        short: "1.) Extranjería Policial I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1035/image1"],
        banner: ["/1035/image1"],
        link: "/tienda/cursos/formacion-policial/curso-extranjeria-policial-i-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1035,
        evolmind: { course_id: 1009, group_id: [2848] },
    },
    // 1037. Curso Extranjería Policial I - CA
    {
        id: 1037,
        tax: 0.21,
        sku: "iopos.course.online.curso-extranjeria-policial-i-2026-ca",
        title: "Curs Estrangeria Policial I",
        name: "Curs Estrangeria Policial I",
        short: "1.) Estrangeria Policial I",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1035/image1"],
        banner: ["/1035/image1"],
        link: "/tienda/cursos/formacion-policial/curso-extranjeria-policial-i-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1035,
        evolmind: { course_id: 1012, group_id: [2851] },
    },
    // 1038. Curso Extranjería Policial II
    {
        id: 1038,
        tax: 0.21,
        sku: "iopos.course.online.curso-extranjeria-policial-ii-2026",
        title: "Curs Estrangeria Policial II",
        name: "Curs Estrangeria Policial II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació avançada orientada a l’actuació policial especialitzada en matèria d’estrangeria, amb especial incidència en documentació fraudulenta, tràfic d’éssers humans i cooperació internacional.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1038/image1"],
        banner: ["/1038/image1"],
        link: "/tienda/cursos/formacion-policial/curso-extranjeria-policial-ii/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1039, 1040],
        multiple_languages: false,
    },
    // 1039. Curso Extranjería Policial II - ES
    {
        id: 1039,
        tax: 0.21,
        sku: "iopos.course.online.curso-extranjeria-policial-ii-2026-es",
        title: "Curso Extranjería Policial II.",
        name: "Curso Extranjería Policial II.",
        short: "1.) Extranjería Policial II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1038/image1"],
        banner: ["/1038/image1"],
        link: "/tienda/cursos/formacion-policial/curso-extranjeria-policial-ii-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1038,
        evolmind: { course_id: 1018, group_id: [2857] },
    },
    // 1040. Curso Extranjería Policial II - CA
    {
        id: 1040,
        tax: 0.21,
        sku: "iopos.course.online.curso-extranjeria-policial-ii-2026-ca",
        title: "Curs Estrangeria Policial II",
        name: "Curs Estrangeria Policial II",
        short: "1.) Estrangeria Policial II",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1038/image1"],
        banner: ["/1038/image1"],
        link: "/tienda/cursos/formacion-policial/curso-extranjeria-policial-ii-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1038,
        evolmind: { course_id: 1015, group_id: [2854] },
    },
    // 1041. Experto en Intervención Policial en Ocupaciones
    {
        id: 1041,
        tax: 0.21,
        sku: "iopos.course.online.experto-intervencion-policial-ocupaciones-2026",
        title: "Curs Expert en Intervenció Policial en Ocupacions.",
        name: "Curs Expert en Intervenció Policial en Ocupacions.",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació tècnica i operativa especialitzada orientada a capacitar els professionals policials en la resposta jurídica i pràctica davant ocupacions il·legals d’immobles, amb plena seguretat jurídica i criteri operatiu.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1041/image1"],
        banner: ["/1041/image1"],
        link: "/tienda/cursos/formacion-policial/experto-intervencion-policial-ocupaciones-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1042, 1043],
        multiple_languages: false,
    },
    // 1042. Experto en Intervención Policial en Ocupaciones - ES
    {
        id: 1042,
        tax: 0.21,
        sku: "iopos.course.online.experto-intervencion-policial-ocupaciones-2026-es",
        title: "Curso Experto en Intervención Policial en Ocupaciones.",
        name: "Curso Experto en Intervención Policial en Ocupaciones.",
        short: "1.) Experto en Intervención Policial en Ocupaciones",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1041/image1"],
        banner: ["/1041/image1"],
        link: "/tienda/cursos/formacion-policial/experto-intervencion-policial-ocupaciones-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1041,
        evolmind: { course_id: 1021, group_id: [2860] },
    },
    // 1043. Experto en Intervención Policial en Ocupaciones - CA
    {
        id: 1043,
        tax: 0.0,
        sku: "iopos.course.online.experto-intervencion-policial-ocupaciones-2026-ca",
        title: "Curs Expert en Intervenció Policial en Ocupacions.",
        name: "Curs Expert en Intervenció Policial en Ocupacions.",
        short: "1.) Expert en Intervenció Policial en Ocupacions",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1041/image1"],
        banner: ["/1041/image1"],
        link: "/tienda/cursos/formacion-policial/experto-intervencion-policial-ocupaciones-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1041,
        evolmind: { course_id: 1024, group_id: [2863] },
    },
    // 1044. Integración y Desarrollo de las Competencias Policiales
    {
        id: 1044,
        tax: 0.0,
        sku: "iopos.course.online.integracion-desarrollo-competencias-policiales-2026",
        title: "Curs Integració i Desenvolupament de les Competències Policials",
        name: "Curs Integració i Desenvolupament de les Competències Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a integrar i desenvolupar les competències professionals, ètiques i emocionals que defineixen el perfil policial dins el marc democràtic i institucional de Catalunya.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1044/image1"],
        banner: ["/1044/image1"],
        link: "/tienda/cursos/formacion-policial/curso-integracion-desarrollo-competencias-policiales-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1045, 1046],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070858",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat d'Integració i Desenvolupament de les Competències Policials",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **integrar** i **desenvolupar** les **competències professionals**, **ètiques** i **emocionals** que defineixen el perfil policial dins el marc democràtic i institucional de Catalunya.",
            landscape: "/1044/hero_h",
            portrait: "/1044/hero_v",
        },
    },
    // 1045. Integración y Desarrollo de las Competencias Policiales - ES
    {
        id: 1045,
        tax: 0.0,
        sku: "iopos.course.online.integracion-desarrollo-competencias-policiales-2026-es",
        title: "Curso Integración y Desarrollo de las Competencias Policiales.",
        name: "Curso Integración y Desarrollo de las Competencias Policiales.",
        short: "1.) Integración y Desarrollo de las Competencias Policiales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1044/image1"],
        banner: ["/1044/image1"],
        link: "/tienda/cursos/formacion-policial/curso-integracion-desarrollo-competencias-policiales-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1044,
        evolmind: { course_id: 1030, group_id: [2869] },
    },
    // 1046. Integración y Desarrollo de las Competencias Policiales - CA
    {
        id: 1046,
        tax: 0.0,
        sku: "iopos.course.online.integracion-desarrollo-competencias-policiales-2026-ca",
        title: "Curs Integració i Desenvolupament de les Competències Policials",
        name: "Curs Integració i Desenvolupament de les Competències Policials",
        short: "1.) Integració i Desenvolupament de les Competències Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1044/image1"],
        banner: ["/1044/image1"],
        link: "/tienda/cursos/formacion-policial/curso-integracion-desarrollo-competencias-policiales-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1044,
        evolmind: { course_id: 1027, group_id: [2866] },
    },
    // 1047. Curso Investigación Criminal
    {
        id: 1047,
        tax: 0.21,
        sku: "iopos.course.online.investigacion-criminal-2026",
        title: "Curs Investigació Criminal",
        name: "Curs Investigació Criminal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació especialitzada orientada a desenvolupar competències tècniques i jurídiques en investigació criminal, garantint actuacions rigoroses, estructurades i jurídicament sòlides.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1047/image1"],
        banner: ["/1047/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-criminal-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1048, 1049],
        multiple_languages: false,
    },
    // 1048. Curso Investigación Criminal - ES
    {
        id: 1048,
        tax: 0.21,
        sku: "iopos.course.online.investigacion-criminal-2026-es",
        title: "Curso Investigación Criminal.",
        name: "Curso Investigación Criminal.",
        short: "1.) Investigación Criminal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1047/image1"],
        banner: ["/1047/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-criminal-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1047,
        evolmind: { course_id: 1036, group_id: [2875] },
    },
    // 1049. Curso Investigación Criminal - CA
    {
        id: 1049,
        tax: 0.21,
        sku: "iopos.course.online.investigacion-criminal-2026-ca",
        title: "Curs Investigació Criminal",
        name: "Curs Investigació Criminal",
        short: "1.) Investigació Criminal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1047/image1"],
        banner: ["/1047/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-criminal-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1047,
        evolmind: { course_id: 1033, group_id: [2872] },
    },
    // 1050. Curso Tiro y Armamento
    {
        id: 1050,
        tax: 0.21,
        sku: "iopos.course.online.tiro-y-armamento-2026",
        title: "Curs Tir i Armament",
        name: "Curs Tir i Armament",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "Formació tècnica especialitzada orientada a garantir un ús segur, proporcional i jurídicament ajustat de l’armament reglamentari en l’àmbit policial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/1050/image1"],
        banner: ["/1050/image1"],
        link: "/tienda/cursos/formacion-policial/curso-tiro-y-armamento-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1051, 1052],
        multiple_languages: false,
    },
    // 1051. Curso Tiro y Armamento - ES
    {
        id: 1051,
        tax: 0.21,
        sku: "iopos.course.online.tiro-y-armamento-2026-es",
        title: "Curso Tiro y Armamento.",
        name: "Curso Tiro y Armamento.",
        short: "1.) Tiro y Armamento",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/1050/image1"],
        banner: ["/1050/image1"],
        link: "/tienda/cursos/formacion-policial/curso-tiro-y-armamento-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1050,
        evolmind: { course_id: 1039, group_id: [2878] },
    },
    // 1052. Curso Tiro y Armamento - CA
    {
        id: 1052,
        tax: 0.21,
        sku: "iopos.course.online.tiro-y-armamento-2026-ca",
        title: "Curs Tir i Armament",
        name: "Curs Tir i Armament",
        short: "1.) Tir i Armament",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/1050/image1"],
        banner: ["/1050/image1"],
        link: "/tienda/cursos/formacion-policial/curso-tiro-y-armamento-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1050,
        evolmind: { course_id: 1042, group_id: [2881] },
    },
    // 1053. Curso Informática Forense en Proceso Penal
    {
        id: 1053,
        tax: 0.0,
        sku: "iopos.course.online.informatica-forense-en-proceso-penal-2026",
        title: "Curs Informàtica Forense en Procés Penal",
        name: "Curs Informàtica Forense en Procés Penal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Formació especialitzada orientada a garantir l’obtenció, anàlisi i gestió de proves digitals amb plena validesa jurídica dins del procés penal.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1053/image2"],
        banner: ["/1053/image2"],
        link: "/tienda/cursos/formacion-policial/curso-informatica-forense-en-proceso-penal-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1054, 1055],
        multiple_languages: false,
    },
    // 1054. Curso Informática Forense en Proceso Penal - ES
    {
        id: 1054,
        tax: 0.0,
        sku: "iopos.course.online.informatica-forense-en-proceso-penal-2026-es",
        title: "Curso Informática Forense en Proceso Penal",
        name: "Curso Informática Forense en Proceso Penal",
        short: "1.) Informática Forense en Proceso Penal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1053/image1"],
        banner: ["/1053/image1"],
        link: "/tienda/cursos/formacion-policial/curso-informatica-forense-en-proceso-penal-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1053,
        evolmind: { course_id: 1045, group_id: [2884] },
    },
    // 1055. Curso Informática Forense en Proceso Penal - CA
    {
        id: 1055,
        tax: 0.0,
        sku: "iopos.course.online.informatica-forense-en-proceso-penal-2026-ca",
        title: "Curs Informática Forense en Procés Penal",
        name: "Curs Informàtica Forense en Procés Penal",
        short: "1.) Informàtica Forense en Procés Penal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1053/image1"],
        banner: ["/1053/image1"],
        link: "/tienda/cursos/formacion-policial/curso-informatica-forense-en-proceso-penal-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1053,
        evolmind: { course_id: 1048, group_id: [2887] },
    },
    // 1056. Curso Operador de Sala
    {
        id: 1056,
        tax: 0.0,
        sku: "iopos.course.online.operador-sala-2026",
        title: "Curs Operador de Sala",
        name: "Curs Operador de Sala",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Formació especialitzada orientada a desenvolupar funcions d’operador/a de sala amb criteri operatiu, rigor procedimental i seguretat jurídica en la gestió d’incidents i recursos.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1056/image1"],
        banner: ["/1056/image1"],
        link: "/tienda/cursos/formacion-policial/curso-operador-de-sala-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1057, 1058],
        multiple_languages: false,
    },
    // 1057. Curso Operador de Sala - ES
    {
        id: 1057,
        tax: 0.0,
        sku: "iopos.course.online.operador-sala-2026-es",
        title: "Curso Operador de Sala",
        name: "Curso Operador de Sala",
        short: "1.) Operador de Sala",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1056/image1"],
        banner: ["/1056/image1"],
        link: "/tienda/cursos/formacion-policial/curso-operador-de-sala-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1056,
        evolmind: { course_id: 1051, group_id: [2890] },
    },
    // 1058. Curso Operador de Sala - CA
    {
        id: 1058,
        tax: 0.0,
        sku: "iopos.course.online.operador-sala-2026-ca",
        title: "Curs Operador de Sala",
        name: "Curs Operador de Sala",
        short: "1.) Operador de Sala",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1056/image1"],
        banner: ["/1056/image1"],
        link: "/tienda/cursos/formacion-policial/curso-operador-de-sala-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1056,
        evolmind: { course_id: 1054, group_id: [2893] },
    },
    // 1059. Curso Sistemas de Comunicación y Radiotransmisiones en Servicios de Emergencia y Seguridad
    {
        id: 1059,
        tax: 0.0,
        sku: "iopos.course.online.sistemas-comunicacion-radiotransmisiones-servicios-emergencia-2026",
        title: "Curs Sistemes de Comunicació i Radiotransmissions en Serveis d'Emergència i Seguretat",
        name: "Curs Sistemes de Comunicació i Radiotransmissions en Serveis d'Emergència i Seguretat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Formació especialitzada orientada a garantir una comunicació operativa eficaç, segura i coordinada mitjançant l’ús correcte dels sistemes de radiotransmissió en serveis d’emergència i seguretat.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1059/image1"],
        banner: ["/1059/image1"],
        link: "/tienda/cursos/formacion-policial/curso-sistemas-comunicacion-radiotransmisiones-servicios-emergencia-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1060, 1061],
        multiple_languages: false,
    },
    // 1060. Curso Sistemas de Comunicación y Radiotransmisiones en Servicios de Emergencia y Seguridad - ES
    {
        id: 1060,
        tax: 0.0,
        sku: "iopos.course.online.sistemas-comunicacion-radiotransmisiones-servicios-emergencia-2026-es",
        title: "Curso Sistemas de Comunicación y Radiotransmisiones en Servicios de Emergencia y Seguridad",
        name: "Curso Sistemas de Comunicación y Radiotransmisiones en Servicios de Emergencia y Seguridad",
        short: "1.) Sistemas de Comunicación y Radiotransmisiones en Servicios de Emergencia y Seguridad",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1059/image1"],
        banner: ["/1059/image1"],
        link: "/tienda/cursos/formacion-policial/curso-sistemas-comunicacion-radiotransmisiones-servicios-emergencia-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1059,
        evolmind: { course_id: 1057, group_id: [2896] },
    },
    // 1061. Curso Sistemas de Comunicación y Radiotransmisiones en Servicios de Emergencia y Seguridad - CA
    {
        id: 1061,
        tax: 0.0,
        sku: "iopos.course.online.sistemas-comunicacion-radiotransmisiones-servicios-emergencia-2026-ca",
        title: "Curs Sistemes de Comunicació i Radiotransmissions en Serveis d'Emergència i Seguretat",
        name: "Curs Sistemes de Comunicació i Radiotransmissions en Serveis d'Emergència i Seguretat",
        short: "1.) Sistemes de Comunicació i Radiotransmissions en Serveis d'Emergència i Seguretat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1059/image1"],
        banner: ["/1059/image1"],
        link: "/tienda/cursos/formacion-policial/curso-sistemas-comunicacion-radiotransmisiones-servicios-emergencia-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1059,
        evolmind: { course_id: 1060, group_id: [2899] },
    },
    // 1062. Curso Sociedad Virtual y Ciberdelincuencia
    {
        id: 1062,
        tax: 0.0,
        sku: "iopos.course.online.sociedad-virtual-ciberdelincuencia-2026",
        title: "Curs Societat Virtual i Ciberdelinqüència",
        name: "Curs Societat Virtual i Ciberdelinqüència",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Formació especialitzada orientada a comprendre l’impacte de la societat digital en la seguretat pública i a intervenir amb criteri davant la ciberdelinqüència i riscos socials associats.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1062/image1"],
        banner: ["/1062/image1"],
        link: "/tienda/cursos/formacion-policial/curso-sociedad-virtual-ciberdelincuencia-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1063, 1064],
        multiple_languages: false,
    },
    // 1063. Curso Sociedad Virtual y Ciberdelincuencia - ES
    {
        id: 1063,
        tax: 0.0,
        sku: "iopos.course.online.sociedad-virtual-ciberdelincuencia-2026-es",
        title: "Curso Sociedad Virtual y Ciberdelincuencia",
        name: "Curso Sociedad Virtual y Ciberdelincuencia",
        short: "1.) Sociedad Virtual y Ciberdelincuencia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1062/image1"],
        banner: ["/1062/image1"],
        link: "/tienda/cursos/formacion-policial/curso-sociedad-virtual-ciberdelincuencia-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1062,
        evolmind: { course_id: 1066, group_id: [2905] },
    },
    // 1064. Curso Sociedad Virtual y Ciberdelincuencia - CA
    {
        id: 1064,
        tax: 0.0,
        sku: "iopos.course.online.sociedad-virtual-ciberdelincuencia-2026-ca",
        title: "Curs Societat Virtual i Ciberdelinqüència",
        name: "Curs Societat Virtual i Ciberdelinqüència",
        short: "1.) Societat Virtual i Ciberdelinqüència",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1062/image1"],
        banner: ["/1062/image1"],
        link: "/tienda/cursos/formacion-policial/curso-sociedad-virtual-ciberdelincuencia-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1062,
        evolmind: { course_id: 1063, group_id: [2902] },
    },
    // 1065. Curso Uso de la Tecnología y Ciberseguridad
    {
        id: 1065,
        tax: 0.0,
        sku: "iopos.course.online.uso-tecnologia-ciberseguridad-2026",
        title: "Curs Ús de la Tecnologia i Ciberseguretat",
        name: "Curs Ús de la Tecnologia i Ciberseguretat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a garantir un ús segur, responsable i jurídicament correcte de la tecnologia i de la informació digital en l’àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1065/image1"],
        banner: ["/1065/image1"],
        link: "/tienda/cursos/formacion-policial/curso-uso-tecnologia-ciberseguridad-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1066, 1067],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070980",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat d'Ús de la Tecnologia i Ciberseguretat",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **garantir** un ús **segur**, **responsable** i **jurídicament correcte** de la **tecnologia** i de la **informació digital** en l’àmbit policial.",
            landscape: "/1065/hero_h",
            portrait: "/1065/hero_v",
        },
    },
    // 1066. Curso Uso de la Tecnología y Ciberseguridad - ES
    {
        id: 1066,
        tax: 0.0,
        sku: "iopos.course.online.uso-tecnologia-ciberseguridad-2026-es",
        title: "Curso Uso de la Tecnología y Ciberseguridad",
        name: "Curso Uso de la Tecnología y Ciberseguridad",
        short: "1.) Uso de la Tecnología y Ciberseguridad",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1065/image1"],
        banner: ["/1065/image1"],
        link: "/tienda/cursos/formacion-policial/curso-uso-tecnologia-ciberseguridad-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1065,
        evolmind: { course_id: 1072, group_id: [2911] },
    },
    // 1067. Curso Uso de la Tecnología y Ciberseguridad - CA
    {
        id: 1067,
        tax: 0.0,
        sku: "iopos.course.online.uso-tecnologia-ciberseguridad-2026-ca",
        title: "Curs Ús de la Tecnologia i Ciberseguretat",
        name: "Curs Ús de la Tecnologia i Ciberseguretat",
        short: "1.) Ús de la Tecnologia i Ciberseguretat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1065/image1"],
        banner: ["/1065/image1"],
        link: "/tienda/cursos/formacion-policial/curso-uso-tecnologia-ciberseguridad-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1065,
        evolmind: { course_id: 1069, group_id: [2908] },
    },
];
exports.default = products;
